module.exports = __webpack_public_path__ + "img/sCrazyMkDx_350x350.664155a4.jpg";